<template>
	<div>
		<topback title="My Assets" path="/my"></topback>
    <div class="noassets">
        <md-result-page
        class="customized"
        img-url="/static/icon/noassets.png"
        text="Your account has no assets"
        subtext="Deposit or buy crypto to start">
        </md-result-page>
    </div>

    <md-field class="assetslist">
      <md-cell-item title="I Token" addon="0.00">
        <div class="holder" slot="left">
          <iconimg name="i" class="assetslist-img"></iconimg>
        </div>
      </md-cell-item>
    </md-field>

    
		<div class="btngroup">
      <div class="btnitem">
        <iconimg name="recharge" class="holder"></iconimg>
        <span class="title">Deposit INR</span>
      </div>
      <div class="btnitem" @click="go_usdt_recharge">
        <iconimg name="usdt" class="holder"></iconimg>
        <span class="title">Deposit USDT</span>
      </div>
    </div>


	</div>

</template>

<script>
import topback from '@/components/topback'
import iconimg from '@/components/iconimg'


export default {
	name: 'asset',

	components: {
		[topback.name]: topback,
    [iconimg.name]: iconimg
	},

	data() {
		return {
			
		}
	},

	methods: {
    go_usdt_recharge() {
      this.$router.push("/depositusdt")
    }
	}
}

</script>
<style scoped>

.btngroup .holder {
  margin: 10px auto;
  display: block;
  width: 80px;
  height: 80px;
  border-radius: 50%;
}

.btnitem .title {
  font-size: 0.1rem;
  margin: 5px;
}

.btngroup {
  margin: 0.2rem 0;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
}

.btngroup .btnitem {
  text-align: center;
  display: flex;
  flex-direction: column;
  background-color: #fff;
  width: calc(90% / 3);
  height: calc(90% / 3);
  border-radius: 20px;
  box-shadow: 0 8px 12px #ebedf0;
  overflow: auto;
}


.assetslist .holder {
  line-height: 0px;
  font-size: 39px;
}
.assetslist-img {
  width: 0.42rem;
}

.assetslist  >>> .md-cell-item-right {
  color: black;
}
.noassets {
  margin-top: 1.5rem;
}
.noassets >>> .md-result-image {
  width: 1.6rem;
}
.noassets >>> .md-result-text {
    margin: 0;
    color: #01080f;
    font-size: 0.12rem;
}

.noassets >>> .md-result-subtext {
    margin-top: 0.16rem;
    color: red;
    font-size: 0.28rem;
}
</style>



// WEBPACK FOOTER //
// src/views/my/asset.vue